import { get, writable } from 'svelte/store'

import { browser } from '$app/environment'
import { getCurrencyFromArray } from '$lib/functions/helpers'
import { apiFetchJson } from '$lib/proxy/apiProxy'
import { getCountry, InitCountries } from '$lib/stores/countries'
import type { Currency } from '$lib/types/client_types'

import { makeCurrency } from '../factories'

export const CURRENCY_SEPARATOR_ID = '--'

const store = writable([] as Currency[])
export { store as storeCurrencies }

let state: 'pending' | 'reading' | 'ready' = 'pending'
let promiseFetch: Promise<Currency[]>

const storeInitialized = () => state === 'ready'

// return true if initializing now
export async function InitCurrencies(pFetch = fetch) {
	if (!browser) return fetchData(pFetch)
	if (state === 'ready') return

	if (state === 'reading') {
		await promiseFetch
		return
	}

	promiseFetch = fetchData(pFetch)
	await promiseFetch
	return
}

async function fetchData(pFetch = fetch) {
	state = 'reading'

	const jsonData = await apiFetchJson(pFetch, 'get', '/lookup/currencies')
	if (!jsonData || jsonData.error) {
		state = 'pending'
		return
	}

	const data = jsonData.currencies
	if (browser) {
		// ensure InitCountries because they are used from the functions.
		await InitCountries()
		store.set(data)
		state = 'ready'
	}

	return data
}

// UP generic ==== Down custom ===================

export function getCurrencyReactiveToStore(store: Currency[], currency_id: string) {
	return getCurrency(currency_id)
}

export function getCurrency(currency_id: string): Currency {
	const allCurrencies = get(store)
	const currency = getCurrencyFromArray(allCurrencies, currency_id, 'usd')
	return currency
}

export function getCurrenciesForCountry(country_id: string) {
	console.log('getCurrenciesForCountry country_id:', country_id)

	const country = getCountry(country_id)
	// console.log('currencies.ts - getCurrenciesForCountry',  country);

	let enabledCurrencies: Currency[] = []
	let otherCurrencies: Currency[] = []

	if (country.currency_id) {
		const defCurrency = getCurrency(country.currency_id)
		enabledCurrencies = [...enabledCurrencies, defCurrency]
	}

	if (country.currencies_valids != '') {
		const validCurrencies = JSON.parse(country.currencies_valids)

		const allCurrencies = get(store)

		allCurrencies.forEach((currency: Currency) => {
			if (currency.id !== country.currency_id) {
				const curr = validCurrencies.find((c) => c === currency.id)
				if (curr) {
					enabledCurrencies = [...enabledCurrencies, currency]
				} else {
					otherCurrencies = [...otherCurrencies, currency]
				}
			}
		})

		// Controls whether to add separator
		if (enabledCurrencies.length > 0 && otherCurrencies.length > 0) {
			// Add Separator
			const currSeparator = makeCurrency()
			currSeparator.id = CURRENCY_SEPARATOR_ID
			enabledCurrencies.push(currSeparator)
		}

		enabledCurrencies = enabledCurrencies.concat(otherCurrencies)
	}

	return enabledCurrencies
}

export function getDefCurrencyForCountry(country_id: string) {
	if (!storeInitialized()) {
		// console.log('currencies.ts - getDefCurrencyForCountry - not initialized');
		return 'usd'
	}

	const country = getCountry(country_id)

	if (country.currency_id) {
		// console.log('currencies.ts - getDefCurrencyForCountry - have currency', country.currency_id);
		return country.currency_id
	}

	// console.log('currencies.ts - getDefCurrencyForCountry - not have currency');
	return 'usd'
}
